"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSuiteDataLocalStorageService = exports.authSuiteDataLocalStorageService = void 0;
var local_storage_service_1 = require("../../local-storage-service");
var models_1 = require("../../models");
var models_2 = require("./models");
var tokens_resolving_strategy_1 = require("./tokens-resolving-strategy");
var storage_entries_1 = require("./models/storage-entries");
var getItem = function (item) {
    return local_storage_service_1.authSuiteLocalStorageService.getItem(item);
};
var setItem = function (item, value) {
    local_storage_service_1.authSuiteLocalStorageService.setItem(item, value);
};
var removeItem = function (item) {
    local_storage_service_1.authSuiteLocalStorageService.removeItem(item);
};
var setClientId = function (clientId) {
    setItem(models_1.AuthSuiteRequestDataType.CLIENT_ID, clientId);
};
var setCountryCode = function (countryCode) {
    setItem(models_1.AuthSuiteRequestDataType.COUNTRY_CODE, countryCode);
};
var setVirginMediaHbaProxy = function (proxy) {
    if ([undefined, null].indexOf(proxy) === -1) {
        setItem(storage_entries_1.StorageEntryKey.VIRGIN_MEDIA_HBA_PROXY, proxy);
    }
    else {
        removeItem(storage_entries_1.StorageEntryKey.VIRGIN_MEDIA_HBA_PROXY);
    }
};
var setAuthSuiteRequestData = function (requestData) {
    setClientId(requestData.clientId);
    setCountryCode(requestData.countryCode);
};
var getClientId = function () {
    return getItem(models_1.AuthSuiteRequestDataType.CLIENT_ID);
};
var getCountryCode = function () {
    return getItem(models_1.AuthSuiteRequestDataType.COUNTRY_CODE);
};
var getAuthSuiteRequestData = function () {
    return {
        clientId: getClientId(),
        countryCode: getCountryCode(),
    };
};
var removeClientId = function () {
    removeItem(models_1.AuthSuiteRequestDataType.CLIENT_ID);
};
var removeCountryCode = function () {
    removeItem(models_1.AuthSuiteRequestDataType.COUNTRY_CODE);
};
var removeAuthSuiteRequestData = function () {
    removeClientId();
    removeCountryCode();
};
var setDeviceRefreshToken = function (token) {
    setItem(models_2.TokenType.DEVICE_REFRESH_TOKEN, token);
};
var setApplicationAccessToken = function (token) {
    setItem(models_2.TokenType.APPLICATION_ACCESS_TOKEN, token);
};
var setAccessTokens = function (accessTokens) {
    setApplicationAccessToken(accessTokens.applicationAccessToken);
    setDeviceRefreshToken(accessTokens.deviceRefreshToken);
};
var getDeviceRefreshToken = function () {
    return getAccessTokens().then(function (tokens) {
        return tokens && tokens.deviceRefreshToken;
    });
};
var getApplicationAccessToken = function () {
    return getAccessTokens().then(function (tokens) {
        return tokens && tokens.applicationAccessToken;
    });
};
var getAccessTokens = function () {
    return tokens_resolving_strategy_1.tokensResolvingContext.getTokens();
};
var removeApplicationAccessToken = function () {
    removeItem(models_2.TokenType.APPLICATION_ACCESS_TOKEN);
};
var removeDeviceRefreshToken = function () {
    removeItem(models_2.TokenType.DEVICE_REFRESH_TOKEN);
};
var removeAccessTokens = function () {
    removeDeviceRefreshToken();
    removeApplicationAccessToken();
};
exports.authSuiteDataLocalStorageService = {
    getAccessTokens: getAccessTokens,
    getApplicationAccessToken: getApplicationAccessToken,
    getAuthSuiteRequestData: getAuthSuiteRequestData,
    getClientId: getClientId,
    getCountryCode: getCountryCode,
    getDeviceRefreshToken: getDeviceRefreshToken,
    removeAccessTokens: removeAccessTokens,
    removeApplicationAccessToken: removeApplicationAccessToken,
    removeAuthSuiteRequestData: removeAuthSuiteRequestData,
    removeClientId: removeClientId,
    removeCountryCode: removeCountryCode,
    removeDeviceRefreshToken: removeDeviceRefreshToken,
    setAccessTokens: setAccessTokens,
    setApplicationAccessToken: setApplicationAccessToken,
    setAuthSuiteRequestData: setAuthSuiteRequestData,
    setClientId: setClientId,
    setCountryCode: setCountryCode,
    setDeviceRefreshToken: setDeviceRefreshToken,
    setVirginMediaHbaProxy: setVirginMediaHbaProxy,
};
var AuthSuiteDataLocalStorageService = /** @class */ (function () {
    function AuthSuiteDataLocalStorageService() {
        return exports.authSuiteDataLocalStorageService;
    }
    return AuthSuiteDataLocalStorageService;
}());
exports.AuthSuiteDataLocalStorageService = AuthSuiteDataLocalStorageService;
